<template>
  <DsFeaturesSection
    title-base="Trámites"
    title-highlight="principales"
    title-id="guia-tramites-principales-title"
    :features="tramites"
  />
</template>

<script setup lang="ts">
import incrementoIcon from '../../../assets/guia-tramites/ic_incremento.svg'
import beneficiariosIcon from '../../../assets/guia-tramites/ic_beneficiarios.svg'
import domiciliacionIcon from '../../../assets/guia-tramites/ic_domiciliacion.svg'
import facturacionIcon from '../../../assets/guia-tramites/ic_facturacion.svg'
import ayudaIcon from '../../../assets/guia-tramites/ic_ayuda.svg'
import DsFeaturesSection from '../components/DsFeaturesSection.vue'

const tramites = [
  {
    id: 'incremento',
    iconSrc: incrementoIcon,
    title: 'Incremento',
    description:
      'Actualiza la cantidad inicial de tu contrato con un máximo de $500,000.00 (exclusivo para etapa de integrante) si requieres más fondos para comprar, remodelar, construir o adquirir más de un inmueble.'
  },
  {
    id: 'beneficiarios',
    iconSrc: beneficiariosIcon,
    title: 'Cambio de beneficiarios',
    description: 'Reasigna a tus beneficiarios estando en la etapa de integrante.'
  },
  {
    id: 'domiciliacion',
    iconSrc: domiciliacionIcon,
    title: 'Domiciliación bancaria',
    description:
      'Método de pago automático y seguro para cubrir tu cuota periódica total sin intervención manual, evitando olvidos y recargos.'
  },
  {
    id: 'facturacion',
    iconSrc: facturacionIcon,
    title: 'Facturación (CFDI 4.0)',
    description:
      'Emisión de facturas fiscales cumpliendo con los requisitos de datos fiscales y constancia de situación fiscal.'
  },
  {
    id: 'ayuda',
    iconSrc: ayudaIcon,
    title: '¿Cómo te ayudan estos tramites?',
    description:
      'Te ofrecen flexibilidad y control absoluto sobre tus contratos, facilitando desde la automatización de tus pagos y la actualización de tus datos hasta el incremento de tu capacidad financiera y el manejo de aclaraciones.'
  }
]
</script>
